import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { State } from '®app/ngrx';
import { ListItem } from '®shared/reading-list';

import {
  DraftItemRequestedAction,
  PublishedItemRequestedAction,
} from './item-resolver-store.actions';
import { selectItemResolverStoreState } from './item-resolver-store.state';

@Injectable()
export class ItemResolverStoreService {
  constructor(private store: Store<State>) {}

  getPublishedItem(itemId: string): Observable<ListItem> {
    return this.store.select(selectItemResolverStoreState).pipe(
      map(state => state.publishedItemsById.get(itemId)),
      tap(loadableItem => {
        if (!loadableItem) {
          this.store.dispatch(new PublishedItemRequestedAction({ itemId }));
        }
      }),
      map(loadableItem => {
        if (loadableItem && loadableItem.loadingError) {
          throw loadableItem.loadingError;
        }

        return loadableItem && loadableItem.data;
      }),
      filter(item => (item ? true : false)),
      first(),
    );
  }

  hasPublishedItem(itemId: string): Observable<boolean> {
    return this.getPublishedItem(itemId).pipe(map(() => true));
  }

  getDraftItem(itemId: string): Observable<ListItem> {
    return this.store.select(selectItemResolverStoreState).pipe(
      map(state => state.draftItemsById.get(itemId)),
      tap(loadableItem => {
        if (!loadableItem) {
          this.store.dispatch(new DraftItemRequestedAction({ itemId }));
        }
      }),
      map(loadableItem => {
        if (loadableItem && loadableItem.loadingError) {
          throw loadableItem.loadingError;
        }

        return loadableItem && loadableItem.data;
      }),
      filter(item => (item ? true : false)),
      first(),
    );
  }

  hasDraftItem(itemId: string): Observable<boolean> {
    return this.getDraftItem(itemId).pipe(map(() => true));
  }
}
